module.exports = __webpack_public_path__ + "static/yoyo-avatar-51e7f5c048858247cabf1a58c35d5aeb.jpg";